import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import { Check } from "lucide-react";
import "./About.css";

const OFFERINGS = [
  "Grills, Rotisseries & Pizza Ovens",
  "Memorial Church Shrines",
  "Decorative & Outdoor Stones",
  "Outdoor Sinks & Fountains",
  "Patio & Outdoor Vases",
  "Sculptures",
];

export default function About() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo === "products") {
      scroller.scrollTo("products", { smooth: true, offset: -70, duration: 500 });
    }
  }, [location]);

  const scrollToProducts = () => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: "products" } });
    } else {
      scroller.scrollTo("products", { smooth: true, offset: -70, duration: 500 });
    }
  };

  return (
    <section id="about" className="about-section">
      <div className="container about-wrapper">
        <div className="about-left">
          <p className="eyebrow">Who We Are</p>
          <h2 className="section-title">Crafted for outdoor living</h2>

          <p className="about-intro">
            We specialize in handcrafted outdoor products designed to enhance gardens, patios,
            terraces, and outdoor living spaces.
          </p>

          <p>
            Our collection includes premium grills, rotisseries, pizza ovens, decorative stones,
            outdoor sinks, fountains, patio vases, sculptures, and memorial church shrines. Every
            product is crafted with quality, durability, and timeless design in mind, helping you
            create outdoor spaces that are both functional and beautiful.
          </p>

          <button type="button" className="btn" onClick={scrollToProducts}>
            Explore Our Collection
          </button>
        </div>

        <div className="about-right">
          <div className="about-offerings-card">
            <h3>What We Offer</h3>
            <div className="divider" />

            <ul className="about-right-list">
              {OFFERINGS.map((item) => (
                <li key={item}>
                  <span className="check-icon">
                    <Check size={13} strokeWidth={3} />
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <p className="mission">
              &ldquo;Craftsmanship, quality, and timeless design are at the heart of everything we
              create. Our collection is designed to transform outdoor spaces into places of
              beauty, comfort, and lasting enjoyment.&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
